<script lang="ts">
  import { goto } from '$app/navigation';
  import { me } from '$src/stores/user.store';
  import type { FPost } from 'garden-common';
  import { createEventDispatcher } from 'svelte';
  import { slide } from 'svelte/transition';

  export let collaborators: FPost<string>['collaborators'];
  export let isEditMode: boolean = false;

  const dispatch = createEventDispatcher();
</script>

{#if collaborators && collaborators.length > 0}
  <div class="flex flex-row items-center justify-start" transition:slide|global>
    <!-- style="transform: translateX(-{i * 9}px);" -->
    <div class="flex flex-row items-center">
      {#key collaborators}
        {#each [{ user: $me, approved: true }, ...collaborators].slice(0, 4) as collaborator, i}
          {#if typeof collaborator.user !== 'string'}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
            <img
              src={collaborator.user?.profileImage ||
                `https://api.dicebear.com/6.x/thumbs/svg?backgroundColor=B5F1D4&shapeColor=074D2B&seed=${collaborator.user?.userName}`}
              alt=""
              class="cursor-pointer w-8 h-8 border-2 border-white rounded-full object-cover"
              style="transform: translateX(-{i * 10}px);"
              on:click={() => {
                if (typeof collaborator.user === 'string') return;
                goto(`/profile/${collaborator.user?.userName}`);
              }}
            />
          {/if}
        {/each}
      {/key}
      {#if isEditMode}
        <button
          class="rounded-full w-8 h-8 bg-brand-green-10 border-2 border-white flex items-center justify-center text-brand-green cursor-pointer"
          style="transform: translateX(-{(collaborators.length < 5 ? collaborators.length + 1 : 4) *
            10}px);"
          on:click={() => {
            dispatch('AddCollaboratorModalOpen');
          }}
        >
          +
        </button>
      {:else}
        <div
          class="rounded-full w-8 h-8 bg-brand-green-10 border-2 border-white flex items-center justify-center text-brand-green cursor-pointer"
          style="transform: translateX(-{(collaborators.length < 5 ? collaborators.length + 1 : 4) *
            10}px);"
        >
          {collaborators.length + 1}
        </div>
      {/if}
    </div>

    <div
      class="text-sm text-blueish-grey-600 font-medium"
      style="transform: translateX(-{(collaborators.length < 5 ? collaborators.length : 3) *
        10}px);"
    >
      {$me.name} and {#if collaborators.length === 1 && collaborators[0]?.user && typeof collaborators[0].user !== 'string'}
        {collaborators[0].user.name}
      {:else}
        {collaborators.length} others
      {/if}
    </div>
  </div>
{/if}
